import Select from "react-select";
import Str from "../../../helpers/Str";
import {IInputSelect} from "../../../types";

/*export type SelectOption<V = string, L = string> = {
    value: V;
    label: L;
}*/

export default function InputSelect({
    selected,
    className,
    margintopClassName,
    label,
    classNameContainer,
    loading,
    options,
    onChangeSelect,
    placeholder,
    isMulti,
    isOptionDisabled,
    isDisabled,
    key,
    value,
    setValue,
    disabled,
    error,
    required,
    isClearable
}: IInputSelect){

    const inputSelectStyle = () => ({
        paddingBottom: '5px',
        paddingTop: '6px',
    });

    const meuPla =  'auto';
    /*if (menuPlacement !== undefined){
        console.log(menuPlacement);
        meuPla = menuPlacement;
    }*/

    /*const backgroundDifferentOptions = (isSelected: any, isFocused: any) => {
        if (isSelected && isFocused) return "#E0A422";
        if (!isSelected && isFocused) return "#E0A422";
        if (isSelected && !isFocused) return "#13131a";
        if (!isSelected && !isFocused) return "#13131a";
    };*/
    return(
        <div key={key} className={Str.tw(className ?? classNameContainer, 'flex flex-col gap-2')}>
            {
                label ?
                    <label className={'font-semibold'}>
                        {label}
                        {required ? <span className='text-red-600'> *</span> : ''}
                    </label>
                    :
                    ''
            }

            <Select
                isClearable={isClearable}
                required={required}
                /*menuPlacement={meuPla}*/
                closeMenuOnSelect={false}
                blurInputOnSelect={false}
                menuPlacement={'auto'}
                isLoading={loading}
                placeholder={placeholder ?? ''}
                value={value
                    ? (isMulti ? options.filter((opt) => value.includes(opt.value)) : options.filter((opt) => opt.value === value))
                    : (options ? options.filter((opt) => opt.value === selected)
                        : [])}

                className={Str.tw(
                    margintopClassName ? (margintopClassName) : (label ? 'mt-[0px]' : 'lg:mt-[1.5rem] sm:mt-[1rem] min-[320px]:mt-[5px] text-[#fff]'),
                )
                }

                options={options}
                onChange={setValue ? (e: any) => setValue(isMulti ? e.map((e: any) => e?.value ?? null) : e?.value ?? null) : onChangeSelect}
                isMulti={isMulti}
                isOptionDisabled={isOptionDisabled}
                isDisabled={isDisabled ?? disabled}
            />
            {!!error?.length && <span className="text-red-600 ">{error}</span>}
        </div>
    )
}